/**
 * Referral update type markers stored in description text.
 * Format: ###L1 Processor Update### at the start of the message.
 */
/** Known update types — new posts use L1 Processor; the rest are legacy parse-only. */
export const REFERRAL_UPDATE_TYPES = [
    {
        id: 'l1-processor',
        label: 'L1 Processor Update',
        shortLabel: 'L1 Processor',
        cssClass: 'l1-processor',
    },
    { id: 'esd113', label: 'ESD113 Update', shortLabel: 'ESD113', cssClass: 'esd113' },
    // Legacy stored marker ###Adjuster Update### — display as Processor.
    { id: 'adjuster', label: 'Adjuster Update', shortLabel: 'Processor', cssClass: 'adjuster' },
    { id: 'admin', label: 'Admin Update', shortLabel: 'Admin', cssClass: 'admin' },
    { id: 'provider', label: 'Provider Update', shortLabel: 'Provider', cssClass: 'provider' },
    { id: 'manager', label: 'Manager Update', shortLabel: 'Manager', cssClass: 'manager' },
    { id: 'inspire', label: 'Inspire Update', shortLabel: 'Inspire', cssClass: 'inspire' },
    {
        id: 'school-building',
        label: 'School/Building',
        shortLabel: 'School/Building',
        cssClass: 'school-building',
    },
    { id: 'system', label: 'System Update', shortLabel: 'System', cssClass: 'system' },
];
const MARKER_RE = /^###\s*([^#]+?)\s*###\s*(?:\r?\n)*/;
const byLabel = new Map(REFERRAL_UPDATE_TYPES.map((type) => [type.label.trim().toLowerCase(), type]));
export function referralUpdateMarker(type) {
    return `###${type.label}###`;
}
export function getReferralUpdateType(id) {
    const found = REFERRAL_UPDATE_TYPES.find((type) => type.id === id);
    if (!found) {
        throw new Error(`Unknown referral update type: ${id}`);
    }
    return found;
}
export function prependReferralUpdateType(description, typeId = 'l1-processor') {
    const body = description.trim();
    const type = getReferralUpdateType(typeId);
    return `${referralUpdateMarker(type)}\n\n${body}`;
}
/** Strip a leading ###Type### marker and resolve the update type when known. */
export function parseReferralUpdateDescription(description) {
    const raw = description ?? '';
    const match = raw.match(MARKER_RE);
    if (!match) {
        return { type: null, body: raw.trim() || '' };
    }
    const label = match[1].trim();
    const type = byLabel.get(label.toLowerCase()) ?? null;
    const body = raw.slice(match[0].length).trim();
    return { type, body };
}
